import { createContext, useContext, useEffect, useMemo } from "react";

const LangContext = createContext(null);
const SITE = "https://gettaxcy.com";

export const useT = () => useContext(LangContext);

const setMeta = (selector, attr, value) => {
  const el = document.querySelector(selector);
  if (el) el.setAttribute(attr, value);
};

export const LangProvider = ({ dict, legal, slug = "", meta, children }) => {
  const value = useMemo(() => {
    const pathFor = (s) => (dict.lang === "el" ? `/el${s}` : s || "/");
    return { ...dict, legal, slug, home: pathFor(""), pathFor };
  }, [dict, legal, slug]);
  useEffect(() => {
    const m = meta || dict.meta;
    const url = `${SITE}${value.pathFor(slug)}`;
    document.documentElement.lang = dict.lang;
    document.title = m.title;
    setMeta('meta[name="description"]', "content", m.description);
    setMeta('link[rel="canonical"]', "href", url);
    setMeta('link[hreflang="en"]', "href", `${SITE}${slug || "/"}`);
    setMeta('link[hreflang="x-default"]', "href", `${SITE}${slug || "/"}`);
    setMeta('link[hreflang="el"]', "href", `${SITE}/el${slug}`);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[property="og:title"]', "content", m.title);
    setMeta('meta[property="og:description"]', "content", m.description);
    setMeta('meta[property="og:locale"]', "content", dict.meta.locale);
    setMeta('meta[name="twitter:title"]', "content", m.title);
    setMeta('meta[name="twitter:description"]', "content", m.description);
  }, [dict, meta, slug, value]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};
